import { render, staticRenderFns } from "./Flights.vue?vue&type=template&id=425a0448&"
import script from "./Flights.vue?vue&type=script&lang=ts&"
export * from "./Flights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports